import { MdShare } from 'react-icons/md';
import { Button, Heading, Icon } from '@nbirl/nbi-common-ui-libs';

import { useCurrentUser } from '../../../../shared/context';
import { Permission } from '../../../../shared/enum';
import { useFolderTree } from '../context';
import { Folder } from '../models';
import { EditFolder } from './edit-folder.component';
import { FolderBreadcrumbs } from './folder-breadcrumbs.component';
import { FolderDropdown } from './folder-dropdown';

type FolderHeaderProps = {
  selectedFolder: Folder;
  onShareFolderClick: () => void;
};

export const FolderHeader: React.FC<FolderHeaderProps> = ({
  selectedFolder,
  onShareFolderClick,
}) => {
  const user = useCurrentUser();
  const { data, isMainFolder, refetch, selectedFolderPath } = useFolderTree();
  const foldersTree = data ?? [];

  const canEditFolder = isMainFolder
    ? user.permissions.includes(Permission.ManageMainFolders)
    : user.permissions.includes(Permission.ManageFolders);

  return (
    <div className="py-6">
      <div className="flex items-center space-x-2 mb-1">
        <Heading className="mr-2">{selectedFolder.name}</Heading>

        {canEditFolder && (
          <EditFolder
            folderId={selectedFolder.id}
            initialName={selectedFolder.name}
            onSuccess={refetch}
          />
        )}

        <Button
          data-tip="Share folder"
          variant="light-teal"
          aria-label="Share folder"
          size="sm"
          onClick={onShareFolderClick}
          onlyIcon
        >
          <Icon size="18" icon={<MdShare />} />
        </Button>

        <FolderDropdown
          currentFolders={
            selectedFolderPath[selectedFolderPath.length - 1]?.subFolders ||
            foldersTree
          }
          selectedFolder={selectedFolder}
          size="sm"
          variant="light-teal"
          isSubFolder={selectedFolderPath.length >= 1}
          onRefetchFolderTree={refetch}
        />
      </div>

      <FolderBreadcrumbs selectedFolder={selectedFolder} />
    </div>
  );
};
